import createIcon from '../../createIcon';

/**
 * @component @name Savings
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuODMgOEwxNy41NiA1LjczQzE3LjYzIDUuMzEgMTcuNzQgNC45MiAxNy44OCA0LjU4QzE3Ljk2IDQuNCAxOCA0LjIxIDE4IDRDMTggMy4xNyAxNy4zMyAyLjUgMTYuNSAyLjVDMTQuODYgMi41IDEzLjQxIDMuMjkgMTIuNSA0LjVINy41QzQuNDYgNC41IDIgNi45NiAyIDEwQzIgMTMuMDQgNC41IDIxLjUgNC41IDIxLjVIMTBWMTkuNUgxMlYyMS41SDE3LjVMMTkuMTggMTUuOTFMMjIgMTQuOTdWOEgxOS44M1pNMTMgOS41SDhWNy41SDEzVjkuNVpNMTYgMTEuNUMxNS40NSAxMS41IDE1IDExLjA1IDE1IDEwLjVDMTUgOS45NSAxNS40NSA5LjUgMTYgOS41QzE2LjU1IDkuNSAxNyA5Ljk1IDE3IDEwLjVDMTcgMTEuMDUgMTYuNTUgMTEuNSAxNiAxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Savings = createIcon('Savings', [
  [
    'path',
    {
      d: 'M19.83 8L17.56 5.73C17.63 5.31 17.74 4.92 17.88 4.58C17.96 4.4 18 4.21 18 4C18 3.17 17.33 2.5 16.5 2.5C14.86 2.5 13.41 3.29 12.5 4.5H7.5C4.46 4.5 2 6.96 2 10C2 13.04 4.5 21.5 4.5 21.5H10V19.5H12V21.5H17.5L19.18 15.91L22 14.97V8H19.83ZM13 9.5H8V7.5H13V9.5ZM16 11.5C15.45 11.5 15 11.05 15 10.5C15 9.95 15.45 9.5 16 9.5C16.55 9.5 17 9.95 17 10.5C17 11.05 16.55 11.5 16 11.5Z',
      key: 'ui43bu',
    },
  ],
]);

export default Savings;
